<template>
    <a :href="link">
        <slot/>
    </a>
</template>

<script>
    import { getWhatsappLink } from 'util/dom/whatsapp-link';

    export default {
        props: {
            query: {
                type: String,
                required: true,
            },
        },
        computed: {
            link() {
                return getWhatsappLink(this.query);
            },
        },
    };
</script>
